export default "__VITE_ASSET__a7463ed0__"